import { LuBook, LuShare } from 'react-icons/lu';

export default function Guide() {
  return (
    <div className="container mb-5 px-3 px-md-4 py-4" style={{ maxWidth: '800px' }}>
      {/* En-tête */}
      <div className="text-center mb-4 pb-2 border-bottom">
        <h2 className="display-6 fw-bold mb-2">
          <LuBook/> Guide d'installation mobile
        </h2>
        <p className="text-muted">Ajoutez l'application à votre écran d'accueil en quelques étapes</p>
      </div>

      {/* Options Android */}
      <section className="mb-5">
        <div className="d-flex align-items-center gap-2 mb-3">
          <i className="fa-brands fa-android" style={{ fontSize: '32px', color: '#3DDC84' }}></i>
          <h3 className="h5 fw-semibold mb-0">Android</h3>
          <span className="badge bg-success ms-2">2 options</span>
        </div>
        <div className="card shadow-sm border-0 bg-light">
          <div className="card-body p-3 p-md-4">
            <ol className="list-unstyled mb-0 d-flex flex-column gap-3">
              <li className="d-flex align-items-start gap-3">
                <span className="badge bg-primary rounded-circle p-2 mt-1" style={{ minWidth: '28px', minHeight: '28px' }}>
                  1
                </span>
                <span>Cliquer sur la bannière en bas de page : <strong>"Ajouter SpotyPark à l'écran d'accueil"</strong></span>
              </li>
              <li className="d-flex align-items-start gap-3">
                <span className="badge bg-primary rounded-circle p-2 mt-1" style={{ minWidth: '28px', minHeight: '28px' }}>
                  2
                </span>
                <span>Via le menu des 3 points verticaux en bas à droite <strong>⋮</strong> puis <strong>"Ajouter à l'écran d'accueil ou installer et créer un raccourci"</strong></span>
              </li>
              <li className="d-flex align-items-start gap-3">
                <span className="badge bg-success rounded-circle p-2 mt-1" style={{ minWidth: '28px', minHeight: '28px' }}>
                  ✓
                </span>
                <span>L'icône d'application <strong>SpotyPark</strong> apparaît sur l'écran de votre smartphone</span>
              </li>
            </ol>
          </div>
        </div>
      </section>

      {/* Options iOS */}
      <section>
        <div className="d-flex align-items-center gap-2 mb-3">
          <i className="fa-brands fa-safari" style={{ fontSize: '32px', color: '#0066CC' }}></i>
          <h3 className="h5 fw-semibold mb-0">iPhone / Safari</h3>
          <span className="badge bg-primary ms-2">5 étapes</span>
        </div>
        <div className="card shadow-sm border-0 bg-light">
          <div className="card-body p-3 p-md-4">
            <ol className="list-unstyled mb-0 d-flex flex-column gap-3">
              <li className="d-flex align-items-start gap-3">
                <span className="badge bg-primary rounded-circle p-2 mt-1" style={{ minWidth: '28px', minHeight: '28px' }}>
                  1
                </span>
                <span>Cliquer sur l'icône <strong>Partager</strong> <LuShare className="text-primary mx-1" size={20} /> (en bas au centre)</span>
              </li>
              <li className="d-flex align-items-start gap-3">
                <span className="badge bg-primary rounded-circle p-2 mt-1" style={{ minWidth: '28px', minHeight: '28px' }}>
                  2
                </span>
                <span>Faire défiler vers le bas</span>
              </li>
              <li className="d-flex align-items-start gap-3">
                <span className="badge bg-primary rounded-circle p-2 mt-1" style={{ minWidth: '28px', minHeight: '28px' }}>
                  3
                </span>
                <span>Appuyer sur <strong>"Sur l'écran d'accueil"</strong></span>
              </li>
              <li className="d-flex align-items-start gap-3">
                <span className="badge bg-primary rounded-circle p-2 mt-1" style={{ minWidth: '28px', minHeight: '28px' }}>
                  4
                </span>
                <span>Appuyer sur <strong>"Ajouter"</strong></span>
              </li>
              <li className="d-flex align-items-start gap-3">
                <span className="badge bg-success rounded-circle p-2 mt-1" style={{ minWidth: '28px', minHeight: '28px' }}>
                  ✓
                </span>
                <span>L'icône <strong>SpotyPark</strong> apparaît sur le bureau</span>
              </li>
            </ol>
          </div>
        </div>
      </section>

      {/* Message de fin */}
      <div className="alert alert-success mt-4 mb-0 d-flex align-items-center gap-2" role="alert">
        <span className="fs-4">✨</span>
        <span className="fw-semibold">C'est fait ! Retrouvez SpotyPark directement depuis l'écran d'accueil de votre smartphone.</span>
      </div>
    </div>
  );
}